import {
  APIGetRequest,
  OrderFormat,
  PurchaseProductDetails,
  SystemVisibility,
} from '@ancon/wildcat-types'

import Request from '../../client/Request'
import endpoints from '../endpoints'

type ProductsAPI = {
  get: {
    details: APIGetRequest<
      {
        purchaseProduct: PurchaseProductDetails
      },
      {
        productId: string
        outletId: string
        systemVisibility: SystemVisibility
        orderFormat: OrderFormat
        purchaseOrderFormat: OrderFormat
        orderTime: string
      }
    >
  }
}

const products: ProductsAPI = {
  get: {
    details: new Request(endpoints.core.outlets.byId.products.byId.details, {
      version: 1.2,
    }).get,
  },
}

export default products
